import React from "react";
import {ListItem} from "@material-ui/core";
import "./SuggestedLocationResult.scss"
import {Suggestion} from "../../../../models/AddressResultCollection";
import {Link} from "react-router-dom";
import {baseUrl} from "../../../../routes/routes";

interface ISuggestedLocationProps {
  suggestion: Suggestion;
  searchValue: string;
}

/**
 * Reusable component for defining a location search result
 * @param suggestion
 * @param searchValue
 * @constructor
 */
const SuggestedLocationResult: React.SFC<ISuggestedLocationProps> = ({suggestion, searchValue}: ISuggestedLocationProps) => {

  // This bit is just to encode the url the same way D6 pkl was, IT'S WEIRD I KNOW!
  let locationName = (suggestion.name.toLowerCase().replace(/\s+/g, '-'));
  locationName = encodeURIComponent(locationName);
  let link = '';
  switch (suggestion.type) {
    case 'location':
      link = `${baseUrl}location/${suggestion.addressId}-${locationName}`;
      break;
    case 'suggest':
      link = `${baseUrl}?q=${encodeURIComponent(suggestion.name)}`;
      break;
    default:
      link = `${baseUrl}${encodeURIComponent(suggestion.name)}`;
  }
  return (
      <Link to={link}>
        <ListItem key={suggestion.name} dense button selected={searchValue === suggestion.name} className="location-suggestion-item">
          <div key={suggestion.name} className="location-suggestion-container">
            <div className="location-information-container">
              <div className="location-content">
                <span className="location-name-text">{suggestion.name}</span>
                {suggestion.address && <span className="location-address-text">{suggestion.address}</span>}
              </div>
            </div>
          </div>
      </ListItem>
      </Link>
  );
};

export default SuggestedLocationResult;


// WEBPACK FOOTER //
// ./src/components/PostshopLocator/LocatorSearch/SuggestedLocationResult/SuggestedLocationResult.tsx